<template>
  <ConfirmModal persist wrapper-class="max-w-2xl" data-testid="iq-activate-modal" @close-dialog="handleCloseDialog">
    <template #title>
      <h1 class="flex items-center p-6 pb-0 text-headline-m">
        {{ t('InvitationQuota.CrewQuota.activateTicketsModal.title', props.ticketIds.length) }}
      </h1>
    </template>
    <template #content>
      <p class="px-6 pt-4">
        {{ t('InvitationQuota.CrewQuota.activateTicketsModal.description', props.ticketIds.length) }}
      </p>
    </template>
    <template #actions>
      <div class="mt-6 flex justify-end px-6 pb-6">
        <button class="btn-link-neutral-s txt-body-s-bold uppercase" data-testid="iq-activate-cancel" @click="handleCloseDialog(false)">
          {{ t('InvitationQuota.CrewQuota.activateTicketsModal.cancelButton') }}
        </button>
        <button class="btn-primary-destructive-s ml-4" data-testid="accept-button" @click="handleCloseDialog(true)">
          {{ t('InvitationQuota.CrewQuota.activateTicketsModal.activateButton') }}
        </button>
      </div>
    </template>
  </ConfirmModal>
</template>
<script lang="ts" setup>
import { captureException } from '@sentry/vue'
import { useI18n } from 'vue-i18n'

import { useActivateTicketMutation } from '@/gql/myomr'
import { injectStrict } from '@/helpers/injectStrict'
import { showNotification } from '@/helpers/notificationHelper'
import { reloadTicketsKey } from '@/symbols/reloadTicketsKey'

import getSettledMutationErrors from './getSettledMutationErrors'
import handleTicketMutationErrors from './handleTicketMutationErrors'

const reloadTickets = injectStrict(reloadTicketsKey)
const { t } = useI18n()
const { mutate: activateTicketMutation } = useActivateTicketMutation()

const props = defineProps<{
  ticketIds: Array<string>
}>()

const emit = defineEmits<{
  (e: 'closeDialog', value: boolean): void
}>()

async function handleCloseDialog(persist: boolean) {
  if (!persist) return emit('closeDialog', false)

  try {
    const responses = await Promise.allSettled(props.ticketIds.map((ticketId) => activateTicketMutation({ ticketId })))
    const errorsMap = responses.map((response) => getSettledMutationErrors(response, (value) => value.data?.activateTicket?.errors))
    handleTicketMutationErrors(
      t,
      errorsMap,
      'InvitationQuota.CrewQuota.unsuccessfulUpdateNotification',
      'InvitationQuota.CrewQuota.successfulUpdateNotification',
    )
  } catch (e) {
    captureException(e)
    showNotification(t('InvitationQuota.CrewQuota.unsuccessfulUpdateNotification'), 'error', 3000)
  }
  reloadTickets()
  emit('closeDialog', true)
}
</script>
